// extracted by mini-css-extract-plugin
module.exports = {"inline":"style_inline__vY7rG"};